import { smoothCornersIndividual } from "apparatus/draw";
import { P, R, Segments, SharedColors } from "apparatus/library/common";
import { Group, Path, PointText, Shape } from "paper";
/**
 * https://www.youtube.com/watch?v=JzNe-Bk2shQ
 */
export class Spectrophotometer {
    render(appearance) {
        const outerColor = SharedColors.deviceGrey.color();
        const outer = new Path(Segments([[0, 0]], // 0
        [[110, 0]], // 1 - Start well
        [[110, 100]], [[185, 100]], [[185, 0]], // 4 - End well
        [[200, 0]], [[200, 110]], [[0, 110]])).close().withStroke("default")
            .withGradientFill("down", [
            [outerColor.hex(), 0.62],
            [outerColor.ladd(-10).hex(), 0.68],
            [outerColor.ladd(-20).hex(), 1.0]
        ]);
        smoothCornersIndividual(outer, { 0: 8, 2: 5, 3: 5, 5: 8, 6: 8, 7: 8 });
        const screenCase = Shape.Rectangle(R(10, 10, 90, 50), 5.0)
            .withStroke("default", SharedColors.devicePanel.stroke)
            .withFill(SharedColors.devicePanel.fill);
        const screen = Shape.Rectangle(R(15, 15, 40, 27), 3.0)
            .withStroke(2.0, "white").withFill(SharedColors.lcdScreen);
        const dpad = this.dpad();
        dpad.position.x = 77;
        dpad.position.y = 30;
        dpad.rotate(45);
        const textAbs = new PointText({
            point: P(50, 27),
            content: appearance.absorbance,
            fillColor: "black",
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
            fontSize: 10,
            justification: "right",
        });
        const textWavelength = new PointText({
            point: P(50, 37),
            content: appearance.wavelength + " nm",
            fillColor: "black",
            fontFamily: 'sans-serif',
            fontWeight: 'bold',
            fontSize: 8,
            justification: "right",
        });
        const graphic = new Group([outer, screenCase, screen, dpad, textAbs, textWavelength]);
        return {
            graphic,
            hitShape: graphic.bounds.toShape(),
            watermark: screen.bounds.bottomRight.add([5, 5]),
            snapping: [
                outer.placeable(),
                { type: "placeable_surface", start: P(110, 100), end: P(185, 100) }
            ]
        };
    }
    dpad() {
        const button = Shape.Rectangle(R(0, 0, 9, 9), 2.0).withFill("white");
        const button2 = button.clone();
        const button3 = button.clone();
        const button4 = button.clone();
        button2.position.x += 12;
        button3.position.y += 12;
        button4.position.x += 12;
        button4.position.y += 12;
        return new Group([button, button2, button3, button4]);
    }
}
Spectrophotometer.properties = {
    label: "Spectrophotometer",
    defaultAppearance: {
        wavelength: "540",
        absorbance: "0.042",
    },
    appearanceSpecs: [
        { spec: "text", key: "absorbance", label: "Absorbance", maxLength: 5 },
        { spec: "text", key: "wavelength", label: "Wavelength", maxLength: 4, numbersOnly: true }
    ],
};
